import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-br from-white via-purple-50 to-pink-50 rounded-xl sm:rounded-2xl shadow-lg sm:shadow-2xl p-4 sm:p-6 lg:p-8 border border-purple-100" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 sm:mb-6 gap-3 sm:gap-0" }
const _hoisted_3 = { class: "bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 sm:px-5 py-2 sm:py-2.5 rounded-lg sm:rounded-xl text-xs sm:text-sm font-bold shadow-lg hover:shadow-xl transition-shadow self-start sm:self-auto" }
const _hoisted_4 = { class: "bg-white rounded-lg sm:rounded-xl shadow-md sm:shadow-lg p-3 sm:p-4 lg:p-6 border border-slate-100" }
const _hoisted_5 = { class: "mt-4 sm:mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4" }
const _hoisted_6 = { class: "bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-3 sm:p-4 border border-purple-200" }
const _hoisted_7 = { class: "flex items-center gap-2 sm:gap-3" }
const _hoisted_8 = { class: "min-w-0 flex-1" }
const _hoisted_9 = { class: "text-sm sm:text-base lg:text-lg font-bold text-purple-900 truncate" }
const _hoisted_10 = { class: "bg-gradient-to-br from-pink-50 to-pink-100 rounded-lg p-3 sm:p-4 border border-pink-200" }
const _hoisted_11 = { class: "flex items-center gap-2 sm:gap-3" }
const _hoisted_12 = { class: "min-w-0 flex-1" }
const _hoisted_13 = { class: "text-xs sm:text-sm font-bold text-pink-900 truncate" }

import { computed } from 'vue';
import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import { TooltipComponent, LegendComponent } from 'echarts/components';
import { VentasCategoriaInterface } from '../interfaces/ventasCategoria.interface';
import * as echarts from 'echarts/core';

interface Props {
  data?: VentasCategoriaInterface;
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VentasCategoriaChart',
  props: {
    data: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

use([CanvasRenderer, PieChart, TooltipComponent, LegendComponent]);

const props = __props;

// Altura responsiva del gráfico
const chartHeight = computed(() => {
  if (typeof window !== 'undefined') {
    if (window.innerWidth < 640) return '350px'; // móvil
    if (window.innerWidth < 1024) return '400px'; // tablet
    return '450px'; // desktop
  }
  return '450px';
});

const chartOption = computed(() => {
  const categorias = props.data?.data || [];
  
  const data = categorias.map(cat => ({
    name: cat.nombreCategoria,
    value: cat.totalVentas
  }));

  // Configuración responsiva
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;
  const isTablet = typeof window !== 'undefined' && window.innerWidth < 1024;

  return {
    tooltip: {
      trigger: 'item',
      formatter: '{b}<br/>S/ {c} ({d}%)',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderColor: '#3b82f6',
      borderWidth: 2,
      textStyle: {
        color: '#1e293b',
        fontSize: isMobile ? 11 : 13,
        fontWeight: 600
      },
      padding: isMobile ? [8, 12] : [10, 15],
      extraCssText: 'box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-radius: 8px;'
    },
    legend: {
      orient: isMobile ? 'horizontal' : 'vertical',
      right: isMobile ? 'center' : '5%',
      top: isMobile ? 'bottom' : 'center',
      bottom: isMobile ? '0%' : 'auto',
      type: 'scroll',
      textStyle: {
        fontSize: isMobile ? 10 : isTablet ? 11 : 13,
        fontWeight: 500,
        color: '#334155'
      },
      itemWidth: isMobile ? 12 : 16,
      itemHeight: isMobile ? 12 : 16,
      itemGap: isMobile ? 8 : 12,
      icon: 'circle',
      formatter: (name: string) => {
        const item = data.find(d => d.name === name);
        if (isMobile) {
          return item ? `${name.length > 12 ? name.substring(0, 12) + '...' : name}` : name;
        }
        return item ? `${name}  S/ ${item.value.toFixed(2)}` : name;
      },
      pageButtonPosition: 'end',
      pageIconSize: isMobile ? 10 : 12
    },
    series: [
      {
        name: 'Ventas',
        type: 'pie',
        radius: isMobile ? ['35%', '65%'] : ['45%', '75%'],
        center: isMobile ? ['50%', '45%'] : isTablet ? ['40%', '50%'] : ['35%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: isMobile ? 8 : 12,
          borderColor: '#fff',
          borderWidth: isMobile ? 2 : 3,
          shadowBlur: isMobile ? 10 : 15,
          shadowColor: 'rgba(0, 0, 0, 0.2)',
          shadowOffsetX: isMobile ? 1 : 2,
          shadowOffsetY: isMobile ? 1 : 2
        },
        label: {
          show: false
        },
        emphasis: {
         
          itemStyle: {
            shadowBlur: isMobile ? 15 : 25,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: 'rgba(0, 0, 0, 0.3)'
          },
          scale: true,
          scaleSize: isMobile ? 10 : 15
        },
        labelLine: {
          show: false
        },
        data
      }
    ],
    color: [
      new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        { offset: 0, color: '#60a5fa' },
        { offset: 1, color: '#3b82f6' }
      ]),
      new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        { offset: 0, color: '#34d399' },
        { offset: 1, color: '#10b981' }
      ]),
      new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        { offset: 0, color: '#fbbf24' },
        { offset: 1, color: '#f59e0b' }
      ]),
      new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        { offset: 0, color: '#f87171' },
        { offset: 1, color: '#ef4444' }
      ]),
      new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        { offset: 0, color: '#a78bfa' },
        { offset: 1, color: '#8b5cf6' }
      ]),
      new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        { offset: 0, color: '#f472b6' },
        { offset: 1, color: '#ec4899' }
      ]),
      new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        { offset: 0, color: '#2dd4bf' },
        { offset: 1, color: '#14b8a6' }
      ])
    ]
  };
});

const totalVentas = computed(() => {
  return props.data?.data?.reduce((sum, cat) => sum + cat.totalVentas, 0).toFixed(2) || '0.00';
});

const categoriaTop = computed(() => {
  const categorias = props.data?.data || [];
  if (categorias.length === 0) return null;
  return categorias.reduce((max, cat) => 
    cat.totalVentas > max.totalVentas ? cat : max
  , categorias[0]);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", null, [
        _createElementVNode("h3", { class: "text-lg sm:text-xl lg:text-2xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-1 sm:mb-2" }, " Ventas por Categoría "),
        _createElementVNode("p", { class: "text-xs sm:text-sm text-slate-600 font-medium" }, "Distribución de ingresos por categoría")
      ], -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.data?.data?.length || 0) + " Categorías ", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(VChart), {
        option: chartOption.value,
        loading: __props.loading,
        style: _normalizeStyle({ height: chartHeight.value }),
        class: "rounded-lg"
      }, null, 8, ["option", "loading", "style"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-9 h-9 sm:w-10 sm:h-10 bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg flex items-center justify-center shadow-md flex-shrink-0" }, [
            _createElementVNode("svg", {
              class: "w-4 h-4 sm:w-5 sm:h-5 text-white",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-xs text-purple-600 font-semibold" }, "Total Ventas", -1)),
            _createElementVNode("p", _hoisted_9, "S/ " + _toDisplayString(totalVentas.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-9 h-9 sm:w-10 sm:h-10 bg-gradient-to-br from-pink-500 to-pink-600 rounded-lg flex items-center justify-center shadow-md flex-shrink-0" }, [
            _createElementVNode("svg", {
              class: "w-4 h-4 sm:w-5 sm:h-5 text-white",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-xs text-pink-600 font-semibold" }, "Categoría Top", -1)),
            _createElementVNode("p", _hoisted_13, _toDisplayString(categoriaTop.value?.nombreCategoria || 'N/A'), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})